/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsDiagType';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsDiagItem interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsDiagItem(value) {
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Type': FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSON(json['Type']),
        'ServerType': json['ServerType'] == null ? undefined : json['ServerType'],
        'ServerName': json['ServerName'] == null ? undefined : json['ServerName'],
        'Port': json['Port'] == null ? undefined : json['Port'],
        'Count': json['Count'] == null ? undefined : json['Count'],
        'MaxTime': json['MaxTime'] == null ? undefined : json['MaxTime'],
        'ResultFile': json['ResultFile'] == null ? undefined : json['ResultFile'],
        'SourceName': json['SourceName'] == null ? undefined : json['SourceName'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Type': FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSON(value['Type']),
        'ServerType': value['ServerType'],
        'ServerName': value['ServerName'],
        'Port': value['Port'],
        'Count': value['Count'],
        'MaxTime': value['MaxTime'],
        'ResultFile': value['ResultFile'],
        'SourceName': value['SourceName'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsDiagItem.js.map